import LocalStorage from '../../../services/LocalStorage'

const Local = new LocalStorage()

const state = {
    email: Local.get('customer.email'),
}

const getters = {
    email: (state) => {
        return state.email
    },
}

const actions = {
    saveEmail({ commit }, email) {
        commit('SAVE_EMAIL', email)
    }
}

const mutations = {
    SAVE_EMAIL (state, email) {
        state.email = email;

        Local.save('customer.email', email)
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
